import React from "react";
import AppStore from "../../assets/application/applogo.png";
import PlayStore from "../../assets/application/googleplay.png";
import "./Application.css";
import { useTranslation } from "react-i18next";
const Application = () => {
  const { t } = useTranslation();
  return (
    <>
      <div className="container mt50">
        <p className="text-uppercase text-center fs-11 pt-5 mb-0 fw-lighter">
          MÜKEMEL
        </p>
        <h3 className="text-center pt-0 pb-5 fw-light">
          {t("MobileApplications")}
        </h3>

        <div className="row text-center justify-content-center">
          <div className="col-lg-4 col-md-5 col-sm-6 mb-5">
            <a
              href="https://apps.apple.com/us/app/m%C3%BCkemel/id6753164005"
              target="__blank"
              className="border p-4 rounded-3"
            >
              <img src={AppStore} alt="App Store" width={200} height={43} />
            </a>
          </div>
          <div className="col-lg-4 col-md-5 col-sm-6 mb-5">
            <a
              href="https://play.google.com/store/apps/details?id=com.murataktas61.mukemelapp"
              target="__blank"
              className="border p-4 bg-light  rounded-3"
              aria-disabled="true"
              tabIndex="-1"
            >
              <img src={PlayStore} alt="App Store" width={200} height={43} />
            </a>
          </div>
        </div>
      </div>
    </>
  );
};

export default Application;
